import isStripePayment from './is-stripe-payment'

export default (paymentProviders = []) => [
  {
    name: 'Refund Provider',
    prop: 'payment_provider_id',
    type: 'autocomplete',
    references: 'admin/payment_providers',
    referenceProp: 'name'
  },
  {
    name: 'Amount',
    prop: 'amount',
    type: 'text'
  },
  {
    name: 'Refund Date',
    prop: 'refund_date',
    type: 'datetime',
    showIf: resource => !isStripePayment(resource, paymentProviders)
  },
  {
    name: 'Reference Number',
    prop: 'reference_number',
    type: 'text',
    showIf: resource => !isStripePayment(resource, paymentProviders)
  },
  {
    name: 'Reason',
    prop: 'reason',
    type: 'textarea'
  },
  {
    name: 'Create credit memo',
    prop: 'credit_memo',
    type: 'checkbox',
    toggled: true
  }
]
